import { addToBasket } from '~/common';
import $ from '~/qwery';
import bean from '~/bean';
import Button from '~/components/button';
import BasketPopup from '~/components/popup/basket-popup';

export default class BasketButton {
    constructor(el) {
        if ($(el).data('basket-button'))
            return $(el).data('basket-button');
        $(el).data('basket-button', this);
        this.$el = $(el);
        const button = new Button(this.$el);
        this.$nItems = $('.n-items', this.$el);
        bean.on(this.$el[0], 'press', () => {
            if (button.disabled())
                return;
            button.disabled(true);
            addToBasket().then(resp => {
                let nItems = resp.data.items.length;
                this.update(nItems);
                if ( ! nItems)
                    return;
                const popup = new BasketPopup(resp.data, {
                    onChange: data => {
                        nItems = data.items.length;
                        this.update(nItems);
                        if ( ! nItems)
                            popup.destroy()
                    },
                    onDestroy: () => {
                        button.disabled( ! nItems);
                        this.$el[0].focus();
                    },
                });
            });
        });
    }

    update(nItems) {
        this.$nItems.text(nItems);
    }
}



// WEBPACK FOOTER //
// ./makosh/assets/components/basket-button.js